/*
 * This sets up observers for user interactions
 * If any of the set interaction corresponding event is triggerd.
 * The events and event parameters are configured by CMS.
*/
import { StateProvider } from '../../services/state-provider';
var globalsetupValues;
var idleTimerID;
var stateManager = StateProvider.getStateManagerInstance();
/*
 * Events metadata - Additional information about the events.
*/
var eventsMetaData = {
    blur: {
        eventActive: false,
        eventType: 'WINDOW',
        functionName: viewFrameBlurEvent,
    },
    idleTimeOut: {
        eventActive: false,
        eventType: 'TIMER',
        timerClearfunction: clearIdleTimeOutTimer,
        timerID: idleTimerID,
    },
    mouseout: {
        eventActive: false,
        eventType: 'WINDOW',
        functionName: viewFrameExitEventTrigger,
    },
};
/*
 * Setting up all user interaction events as per CMS flags
*/
function setupUserInteraction(userInteractionCMSObj) {
    globalsetupValues = userInteractionCMSObj;
    if (globalsetupValues) {
        if (globalsetupValues.viewFrameExitEvent && globalsetupValues.viewFrameExitEvent.triggerEvent) {
            setTimeout(function () { registerMouseMoveEvent(); }, covertSecstoMilliSecs(globalsetupValues.viewFrameExitEvent.startDelay));
        }
        if (globalsetupValues.viewFrameBlurEvent && globalsetupValues.viewFrameBlurEvent.triggerEvent) {
            setTimeout(function () { registerBlurEvent(); }, covertSecstoMilliSecs(globalsetupValues.viewFrameBlurEvent.startDelay));
        }
        if (globalsetupValues.idleTimeoutEvent && globalsetupValues.idleTimeoutEvent.triggerEvent) {
            setImmediate(function () { return registerIdleTimeoutEvent(); });
            setTimerResetEvents();
        }
    }
}
/*
 * Register and trigger functions for mouse out event
*/
function registerMouseMoveEvent() {
    window.addEventListener('mouseout', viewFrameExitEventTrigger);
    eventsMetaData.mouseout.eventActive = true;
}
function viewFrameExitEventTrigger(evt) {
    if (evt.clientY <= globalsetupValues.viewFrameExitEvent.pageTopOffset) {
        stateManager.set('VIEWFRAMEEXITED', { action: 'mouseout', code: 1 });
    }
}
/*
 * Register and trigger functions for blur event
*/
function registerBlurEvent() {
    window.addEventListener('blur', viewFrameBlurEvent);
    eventsMetaData.blur.eventActive = true;
}
function viewFrameBlurEvent() {
    stateManager.set('VIEWFRAMEEXITED', { action: 'blur', code: 2 });
}
/*
 * Register and trigger functions for idle timeout event
*/
function registerIdleTimeoutEvent() {
    idleTimerID = window.setTimeout(idleTimeOutEvent, covertSecstoMilliSecs(globalsetupValues.idleTimeoutEvent.timeoutDelay));
    eventsMetaData.idleTimeOut.eventActive = true;
    eventsMetaData.idleTimeOut.timerID = idleTimerID;
}
function clearIdleTimeOutTimer() {
    window.clearTimeout(idleTimerID);
    registerIdleTimeoutEvent();
}
function setTimerResetEvents() {
    window.addEventListener('mousemove', clearIdleTimeOutTimer);
    window.addEventListener('keypress', clearIdleTimeOutTimer);
    window.addEventListener('scroll', clearIdleTimeOutTimer);
}
function idleTimeOutEvent() {
    stateManager.set('IDLETIMEOUT', { action: 'idleTimeOut', code: 3 });
}
/*
 * Event deregister functions
*/
function deregisterAllEvents() {
    Object.keys(eventsMetaData).forEach(function (eventName) {
        deregisterEvent(eventName);
    });
}
function deregisterEvent(eventType) {
    if (eventType && eventsMetaData && eventsMetaData[eventType] && eventsMetaData[eventType].eventActive) {
        if (eventsMetaData[eventType].eventType === 'WINDOW') {
            window.removeEventListener(eventType, eventsMetaData[eventType].functionName);
            eventsMetaData[eventType].eventActive = false;
        }
        if (eventsMetaData[eventType].eventType === 'TIMER') {
            window.removeEventListener('mousemove', eventsMetaData[eventType].timerClearfunction);
            window.removeEventListener('keypress', eventsMetaData[eventType].timerClearfunction);
            window.removeEventListener('scroll', eventsMetaData[eventType].timerClearfunction);
            window.clearTimeout(idleTimerID);
            window.clearTimeout(eventsMetaData[eventType].timerID);
            eventsMetaData[eventType].eventActive = false;
        }
    }
}
/*
 * Interactions helper functions
*/
function covertSecstoMilliSecs(time) {
    return isNaN(time) ? 0 : time * 1000;
}
export { setupUserInteraction, deregisterAllEvents, deregisterEvent };
//# sourceMappingURL=userInteractionSetup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/UserInteractionFramework/userInteractionSetup.js
// module id = 2393
// module chunks = 8